module.exports = __webpack_public_path__ + "static/media/badge-04-color.32f95c80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badge/badge-04-color.svg
// module id = 244
// module chunks = 0